import { LocaleCode } from '~/types/locales'

export default defineI18nConfig(() => ({
  legacy: false,
  locale: LocaleCode.EN
}))
